/* eslint-disable */
import MainService from '@/services/MainService'

class Session {
  async findById (id: number) {
    const data = {
      route: `ocular/widget/v2/sessions/${id}`,
      params: {}
    }

    return MainService.get(data)
  }
}

const sessionServices = new Session()
export default sessionServices
